module.exports = "mutation notificationDelete($notificationId:ID!){deleteNotification(notificationId:$notificationId)}"